'use strict'
var twentyninetimes = twentyninetimes || {}

const mapStylesGodtsmil = [
  {
    featureType: 'all',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'all',
    elementType: 'labels.text.fill',
    stylers: [
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'all',
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'administrative.country',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#fff2df',
      },
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'administrative.province',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#fff2df',
      },
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'landscape',
    elementType: 'all',
    stylers: [
      {
        visibility: 'on',
      },
      {
        color: '#f3f4f4',
      },
    ],
  },
  {
    featureType: 'landscape.man_made',
    elementType: 'geometry',
    stylers: [
      {
        weight: 0.9,
      },
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'landscape.natural',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#fff2df',
      },
    ],
  },
  {
    featureType: 'landscape.natural.landcover',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#fff2df',
      },
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'landscape.natural.terrain',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#fff2df',
      },
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry.fill',
    stylers: [
      {
        visibility: 'off',
      },
      {
        color: '#fff2df',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'all',
    stylers: [
      {
        visibility: 'off',
      },
      {
        color: '#ff9d00',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'simplified',
      },
      {
        color: '#000000',
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'all',
    stylers: [
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'all',
    stylers: [
      {
        visibility: 'on',
      },
      {
        color: '#ff9d00',
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'geometry',
    stylers: [
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off',
      },
      {
        color: '#000000',
      },
    ],
  },
  {
    featureType: 'road.local',
    elementType: 'all',
    stylers: [
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'all',
    stylers: [
      {
        visibility: 'on',
      },
      {
        color: '#7fc8ed',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#abd3dd',
      },
    ],
  },
]

const mapStylesCosmetics = [
  {
    featureType: 'all',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'all',
    elementType: 'labels.text.fill',
    stylers: [
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'all',
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'administrative.country',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#f6f3ef',
      },
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'administrative.province',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#f6f3ef',
      },
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'landscape',
    elementType: 'all',
    stylers: [
      {
        visibility: 'on',
      },
      {
        color: '#f3f4f4',
      },
    ],
  },
  {
    featureType: 'landscape.man_made',
    elementType: 'geometry',
    stylers: [
      {
        weight: 0.9,
      },
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'landscape.natural',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#f6f3ef',
      },
    ],
  },
  {
    featureType: 'landscape.natural.landcover',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#f6f3ef',
      },
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'landscape.natural.terrain',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#f6f3ef',
      },
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry.fill',
    stylers: [
      {
        visibility: 'off',
      },
      {
        color: '#f6f3ef',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'all',
    stylers: [
      {
        visibility: 'off',
      },
      {
        color: '#ffffff',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'all',
    stylers: [
      {
        visibility: 'simplified',
      },
      {
        color: '#afaca8',
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'all',
    stylers: [
      {
        visibility: 'on',
      },
      {
        color: '#afaca8',
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'geometry',
    stylers: [
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road.local',
    elementType: 'all',
    stylers: [
      {
        color: '#afaca8',
      },
      {
        visibility: 'on',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'all',
    stylers: [
      {
        visibility: 'on',
      },
      {
        color: '#cbc8c4',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#cbc8c4',
      },
    ],
  },
]

const mapStylesTandprotesehuset = [
  {
    featureType: 'all',
    elementType: 'labels.text.fill',
    stylers: [
      {
        saturation: '-100',
      },
      {
        color: '#0c254a',
      },
      {
        lightness: '0',
      },
    ],
  },
  {
    featureType: 'all',
    elementType: 'labels.text.stroke',
    stylers: [
      {
        visibility: 'on',
      },
      {
        color: '#f0eae0',
      },
      {
        lightness: 16,
      },
    ],
  },
  {
    featureType: 'all',
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'administrative',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#f0eae0',
      },
      {
        lightness: 20,
      },
    ],
  },
  {
    featureType: 'administrative',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#000000',
      },
      {
        lightness: 17,
      },
      {
        weight: 1.2,
      },
    ],
  },
  {
    featureType: 'administrative.province',
    elementType: 'labels.text',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'administrative.neighborhood',
    elementType: 'all',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'administrative.land_parcel',
    elementType: 'all',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'landscape',
    elementType: 'geometry',
    stylers: [
      {
        color: '#000000',
      },
      {
        lightness: 20,
      },
    ],
  },
  {
    featureType: 'landscape',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#f0eae0',
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [
      {
        color: '#000000',
      },
      {
        lightness: 21,
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'geometry.fill',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'all',
    stylers: [
      {
        visibility: 'on',
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.fill',
    stylers: [
      {
        lightness: 17,
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [
      {
        lightness: 29,
      },
      {
        weight: 0.2,
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'geometry',
    stylers: [
      {
        lightness: 18,
      },
    ],
  },
  {
    featureType: 'road.local',
    elementType: 'geometry',
    stylers: [
      {
        lightness: 16,
      },
    ],
  },
  {
    featureType: 'transit',
    elementType: 'all',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'transit',
    elementType: 'geometry',
    stylers: [
      {
        color: '#000000',
      },
      {
        lightness: 19,
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [
      {
        color: '#0f252e',
      },
      {
        lightness: 17,
      },
    ],
  },
]

twentyninetimes.maps =
  twentyninetimes.maps ||
  (function () {
    let lazyMaps = [].slice.call(
      document.querySelectorAll('.js-block-map-item')
    )
    const hasCheckout = document.querySelector('#checkout')
    const checkoutButton = document.querySelector('[href="#checkout"]')

    if (!hasCheckout && checkoutButton) {
      checkoutButton.style.display = 'none'
    }

    function init() {
      if (lazyMaps) {
        let inAdvance = 100

        // Check if browser supports IntersectionObserver
        if ('IntersectionObserver' in window) {
          let lazyMapObserver = new IntersectionObserver(
            function (entries, observer) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                  let lazyMap = entry.target

                  setTimeout(() => {
                    mapInit(lazyMap)
                  }, 100)

                  lazyMapObserver.unobserve(lazyMap)
                }
              })
            },
            {
              // Load image when 100px above bo
              rootMargin: '0px 0px -' + inAdvance + 'px 0px',
            }
          )

          lazyMaps.forEach(function (lazyMap) {
            lazyMapObserver.observe(lazyMap)
          })

          // Fallback if browser doesn't support IntersectionObserver
        } else {
          let active = false

          const lazyLoad = function () {
            if (active === false) {
              active = true

              setTimeout(function () {
                lazyMaps.forEach(function (lazyMap) {
                  let element_img = lazyMap.getElementsByTagName('img')[0]

                  if (
                    lazyMap.getBoundingClientRect().top <=
                      window.innerHeight - inAdvance &&
                    lazyMap.getBoundingClientRect().bottom >= 0 &&
                    getComputedStyle(lazyMap).display !== 'none'
                  ) {
                    setTimeout(() => {
                      mapInit(lazyMap)
                    }, 100)

                    lazyMaps = lazyMaps.filter(function (map) {
                      return map !== lazyMap
                    })

                    if (lazyMaps.length === 0) {
                      document.removeEventListener('scroll', lazyLoad)
                      window.removeEventListener('resize', lazyLoad)
                      window.removeEventListener('orientationchange', lazyLoad)
                    }
                  }
                })

                active = false
              }, 200)
            }
          }

          lazyLoad()
          document.addEventListener('scroll', lazyLoad)
          window.addEventListener('resize', lazyLoad)
          window.addEventListener('orientationchange', lazyLoad)
        }
      }
    }

    function mapInit(map) {
      let googleMap
      let markers = []
      let shops

      shops = [...map.querySelectorAll('.js-map-item')].map((item, index) => {
        return {
          id: `map-item-${index}`,
          name: item.getAttribute('data-name'),
          lat: item.getAttribute('data-lat'),
          lng: item.getAttribute('data-lng'),
          url: item.getAttribute('href'),
        }
      })

      const mapElement = map.querySelector('.js-block-map')
      var mapStylesToUse = mapStylesGodtsmil,
        markerIconPath =
          '/wp-content/themes/Godt Smil/__dist/images/icons/marker.svg'

      if (mapElement.classList.contains('js-block-map-cosmetics')) {
        mapStylesToUse = mapStylesCosmetics
      } else if (mapElement.classList.contains('js-theme-tandprotesehuset')) {
        mapStylesToUse = mapStylesTandprotesehuset
        markerIconPath =
          '/wp-content/themes/Tandprotesehuset/__dist/images/icons/marker.svg'
      }

      if (mapElement) {
        var mapOptions = {
          disableDefaultUI: true,
          zoomControl: false,
          styles: mapStylesToUse,
        }

        googleMap = new google.maps.Map(mapElement, mapOptions)

        setMarkers(shops, markerIconPath)

        if (mapElement.classList.contains('js-reset-markers')) {
          var clinicSearcher = document.getElementById('clinic-map-search')

          if (clinicSearcher) {
            var delayTimer

            clinicSearcher.addEventListener('input', () => {
              clearTimeout(delayTimer)
              delayTimer = setTimeout(function () {
                reloadMarkers(markerIconPath)
              }, 250)
            })
          }
        }
      }

      function setMarkers(shops, markerIconPath) {
        let bounds = new google.maps.LatLngBounds()

        shops.map((shop) => {
          if (!shop.lat || !shop.lng) {
            return null
          }

          var latLng = new google.maps.LatLng(
            parseFloat(shop.lat),
            parseFloat(shop.lng)
          )

          bounds.extend(latLng)

          var icon = {
            url: markerIconPath, // url
            scaledSize: new google.maps.Size(25, 30), // scaled size
          }

          var marker = new google.maps.Marker({
            icon: icon,
            position: latLng,
            map: googleMap,
            id: shop.id,
            title: shop.name,
            animation: google.maps.Animation.DROP,
          })

          marker.addListener('click', () => {
            window.location.href = shop.url
          })

          markers.push(marker)
        })

        setBounds(bounds)
      }

      function reloadMarkers(markerIconPath) {
        // Loop through markers and set map to null for each
        for (var i = 0; i < markers.length; i++) {
          markers[i].setMap(null)
        }

        // Reset the markers array
        markers = []

        shops = [
          ...map.querySelectorAll('.js-map-item:not(.js-map-item--hidden)'),
        ].map((item, index) => {
          return {
            id: `map-item-${index}`,
            name: item.getAttribute('data-name'),
            lat: item.getAttribute('data-lat'),
            lng: item.getAttribute('data-lng'),
            url: item.getAttribute('href'),
          }
        })

        // Call set markers to re-add markers
        setMarkers(shops, markerIconPath)
      }

      function setBounds(bounds) {
        if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
          var extendPoint1 = new google.maps.LatLng(
            bounds.getNorthEast().lat() + 0.01,
            bounds.getNorthEast().lng() + 0.01
          )
          var extendPoint2 = new google.maps.LatLng(
            bounds.getNorthEast().lat() - 0.01,
            bounds.getNorthEast().lng() - 0.01
          )
          bounds.extend(extendPoint1)
          bounds.extend(extendPoint2)
        }

        googleMap.fitBounds(bounds)
      }
    }

    return {
      init: init,
      mapInit: mapInit,
    }
  })()
